import { UserCallAvailability } from "@redotech/redo-model/support/voice/voice-types";
import * as z from "zod/v4";

export const createCallAvailability = {
  name: "createCallAvailability" as const,
  input: z.object({ availabilityStatus: z.enum(UserCallAvailability) }),
  output: z.object({ status: z.number() }),
};
